<template>
  <v-theme-provider :dark="dark">
    <div>
      <base-info-card
        title="Nehmen Sie mit uns Kontakt auf"
        pace="6"
      >
        Wenn Sie sich für unsere Dienstleistungen interessieren oder Fragen dazu haben, kontaktieren Sie uns über das Kontaktformular und wir melden uns umgehend bei Ihnen. Gerne finden wir gemeinsam Ihre individuelle Lösung.
      </base-info-card>

      <base-business-contact dense />
    </div>
  </v-theme-provider>
</template>

<script>
  export default {
    name: 'BaseBusinessInfo',

    props: { dark: Boolean },

    data: () => ({
      business: [
        {
          icon: 'mdi-map-marker-outline',
          title: 'Address',
          text: 'Bernrainstrasse 1<br>8280 Kreuzlingen',
        },
        {
          icon: 'mdi-cellphone',
          title: 'Phone',
          text: '+41 71 666 8000',
        },
        {
          icon: 'mdi-email',
          title: 'Email',
          text: 'info@ifea-treuhand.ch',
        },
        {
          icon: 'mdi-clock-check-outline',
          title: 'Öffnungszeiten',
          text: '<p>Montag &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; 13:30 - 17:30<br>Di - Do &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;08:30 - 12:00,<br>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;13:30 - 17:30 &nbsp;<br>Freitag &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;08:00 - 12:00</p>',
        },
      ],
    }),
  }
</script>
